import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../layout/AdminLayout';
import Header from '../../../layout/Partials/Header';
import FormHeader from './FormHeader';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createObject, editObject } from 'redux/actions/objectsAction';
import useRefState from 'lib/FormBuilder/hooks/useRefState';
import api from 'api';
import FormBuilder from 'lib/FormBuilder/components/FormBuilder';
import { qsServerSelector } from 'redux/qsServer/selector';
import config from 'coeus.config';

const defaultObject = {
    sortOrder: '1',
    qsId: 'formObject',
    type: 'formObject',
    xs: 12,
    sm: 6,
    md: '6',
    elevation: 2,
};

const defaultValues = {
    name: 'My Form',
    entity: 'my-form',
    xs: 12,
    sm: 6,
    md: 6,
    elevation: 2,
};

const FormObject = () => {
    const { pageId, rowId, objectId } = useParams();
    const [formId, setFormId] = useState(null);
    const [formElements, formElementsRef, setFormElements] = useRefState([]);
    const [initialValues, setInitialValues] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const loadObject = () => {
        api.objects
            .get(objectId)
            .then((result) => {
                const { form, size, elevation } = result;
                const {
                    name,
                    qlikAppId,
                    entity,
                    elements,
                    _id,
                    persistentData,
                } = form;
                setInitialValues({
                    ...size,
                    elevation,
                    name,
                    entity,
                    persistentData,
                    qlikAppId,
                });
                setFormId(_id);
                setFormElements(elements);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const saveForm = (data) => {
        if (formId) {
            updateForm(data);
        } else {
            createForm(data);
        }
    };

    const updateForm = (formData) => {
        const data = {
            name: formData.name,
            entity: formData.entity,
            elements: formElements,
            persistentData: formData.persistentData,
            qlikAppId: formData.qlikAppId,
        };
        api.forms
            .update(formId, data)
            .then((result) => {
                if (objectId) {
                    const objectData = {
                        ...defaultObject,
                        ...formData,
                        page: pageId,
                        row: rowId,
                        form: result._id,
                    };

                    console.log(pageId, objectId, objectData, history);

                    dispatch(editObject(pageId, objectId, objectData, history));
                } else {
                    history.push(`/settings/pages/${pageId}/view`);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createForm = (formData) => {
        const data = {
            name: formData.name,
            entity: formData.entity,
            elements: formElements,
            persistentData: formData.persistentData,
            qlikAppId: formData.qlikAppId,
        };
        api.forms
            .create(data)
            .then((result) => {
                const objectData = {
                    ...defaultObject,
                    ...formData,
                    page: pageId,
                    row: rowId,
                    form: result._id,
                };
                dispatch(createObject(pageId, objectData, history));
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (config.feature.form_entry.enabled) {
            if (objectId) {
                loadObject();
            } else {
                setInitialValues(defaultValues);
            }
        } else {
            history.push(`/settings/pages/view/${pageId}`);
        }
    }, []);

    const formEndpoint = `GET HTTPS://${window.location.hostname}/api/forms/${
        formId ? formId : ':FormId'
    }/form-content ${
        formId ? '' : '(Form must be saved first to obtain the Form Id)'
    }`;

    return (
        <AdminLayout>
            <div className="o-page">
                <Header hideSearchBar title={'Custom Form'} />
                {initialValues && (
                    <div style={{ padding: '0px 10px 10px 10px' }}>
                        <FormHeader
                            formId={formId}
                            initialValues={initialValues}
                            saveAction={saveForm}
                            formEndpoint={formEndpoint}
                        />
                        <FormBuilder
                            formElements={formElements}
                            formElementsRef={formElementsRef}
                            setFormElements={setFormElements}
                        />
                    </div>
                )}
            </div>
        </AdminLayout>
    );
};

export default FormObject;
